import {useMagnoliaContext} from "./use-magnolia-context";
import {toValue} from "vue";
import {hash} from "ohash";
import {useFetch} from "#app/composables/fetch";
import {FetchOptions} from "ofetch";

export const useMagnoliaFetch: typeof useFetch = (request, opts) => {

  const runtimeConfig = useRuntimeConfig();
  const magnoliaContext = useMagnoliaContext();

  const defaultParams = {
    lang: magnoliaContext.searchParams?.lang,
  }

  const baseURL: string = process.server ? runtimeConfig.mgnl.host : runtimeConfig.public.mgnl.host;

  const configuredFetch = $fetch.create({
    baseURL,
    query: {
      ...defaultParams
    },
  });

  const optsForHash: FetchOptions = {...opts};
  // As the default mechanism for generation the option segments for the hash holds the baseURL in to account,
  // and there's a slight chance we might ask a completely separate API the same query that could lead to hash collisions
  // we're adding a baseURL to make sure the hash takes in to account we're trying to reach our Magnolia instance,
  // be it internally of externally
  optsForHash.baseURL = 'mgnl';
  const key = hash([request, ...generateOptionSegments(opts ?? {}), defaultParams.lang]);

  return useFetch(request, {
    $fetch: configuredFetch,
    key: key,
    ...opts,
  })

}
/**
 * Copied from {@link /node_modules/nuxt/dist/app/composables/fetch.js}
 */
function generateOptionSegments(opts: FetchOptions) {
  const segments = [
    toValue(opts.method)?.toUpperCase() || "GET",
    toValue(opts.baseURL)
  ];
  for (const _obj of [opts.params || opts.query]) {
    const obj = toValue(_obj);
    if (!obj) {
      continue;
    }
    const unwrapped: Record<string, any> = {};
    for (const [key, value] of Object.entries(obj)) {
      unwrapped[toValue(key)] = toValue(value);
    }
    segments.push(unwrapped);
  }
  return segments;
}
